import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getUserInfo, setUserInfo } from "../AuthUtils/AuthUtils";
import {
  ALPHANUM,
  COUNTRY_CODES,
  EMAIL,
  NUMBER_REGEX,
  NUMBER_TWO_DECIMAL,
  PHONE_NUM,
  PATTERN_ERR_MSG,
  SERVER_ERR_MSG,
  ALPHANUM_SPACE_SPCL_CHAR,
  DATE_FORMAT_MOMENT,
  POST_CODE,
  REQUIRED_ERR_MSG,
  COMPANY_REGD_NO_REGEX_FIXED,
} from "../Helper/Constants";
import { CallApiGet, CallApiPut } from "../Helper/serviceApi";
import Header from "../Layout/Header";
import Popup from "../Layout/Popup";
import Spinner from "../Layout/Spinner";
import ApprovalLogList from "../ApprovalWorkFlow/ApprovalLogList";
import {
  APVLLOG,
  LINEHAUL_CUSTOMER_USER_TYPE_LIST,
  LINEHAUL_AGENT_CUSTOMER_USER_TYPE,
  LINEHAUL_CUSTOMER_BUSINESS_PARTNERS,
  LINEHAUL_CUSTOMER_USER_TYPE_PERSONAL,
  LINEHAUL_CUSTOMER_USER_TYPE_BUSINESS,
} from "../../ConfigConstants/ConfigConstants";
import { approvalHistory, permission, toBase64 } from "../Helper/CommonMethods";
import GetSvgIcon, { GetSvgUpload } from "../../images/svglist";
import MultipleFileUpload from "../Utilities/MultipleFileUpload";
import moment from "moment";
import CreatableSelect from "react-select/creatable";
import { sstOptions } from "../Management/Customer/AddCustomerManagement";
import Select from "react-select";
import CustomizeList from "../Helper/CustomizeList";

const initCustProfile = {
  // userId: 62,
  profileId: 0,
  custType: 0,
  acctCode: "",
  custName: "",
  businessName: "",
  businessRegno: "",
  businessNature: "",
  businessAddr: "",
  custEmail: "",
  custPhone: "",
  custAddr: "",
  postcode: "",
  custWebsite: "",
  custIc: "",
  //pickupAddr: "",
  //pickupPerson: "",
  //pickupPhone: "",
  bankName: "",
  bankAcct: "",
  benificiaryName: "",
  appliedBy: "",
  picSales: 0,
  picSalesStaffId: "",
  picSalesStaffName: "",
  picCredit: 0,
  picCreditStaffId: "",
  picCreditStaffName: "",
  creditLimit: 0,
  reqCreditLimit: 0,
  creditTerms: 0,
  debtorCode: "",
  ctosCheck: "",
  status: 0,
  noPayStatus: 0,
  registrationDate: "",
  commitedPallet: 0,
  discount: 0,
  rateChartUrl: "",
  commission: 0.0,
  generalDocList: [],
  sstNumber: "",
  sstNumberSales: "",
};
const customCss = {
  main: "w-100",
  header: {
    levelColor: "fc-black mb-0",
  },
  comp: {
    mainDiv: "row mt-3",
    innerDiv: "col-lg-4 mb-2",
    innerLevel: "uploaded-text ms-2",
  },
};
const customData = {
  headerLevel: "Additional Document",
  defaultName: "Additional Document",
};

const CustomerProfile = () => {
  const [show, setShow] = useState(false);
  const [custPrflDetails, setCustPrflDetails] = useState(
    JSON.parse(JSON.stringify(initCustProfile))
  );
  const [reload, setReload] = useState(0);
  const [isSuccess, setIsSuccess] = useState(false);
  const [description, setDescription] = useState();
  const [title, setTitle] = useState();
  const [isUserActive, setIsUserActive] = useState(false);
  const [approvalHistoryData, setApprovalHistoryData] = useState();
  const [disableCompanyDtls, setDisableCompanyDtls] = useState(false);
  const modalRef = useRef();
  const [isDisabled, setDisabled] = useState({});
  const [stateCity, setStateCity] = useState();
  const [cityListData, setCityListData] = useState();
  const [compCityListData, setCompCityListData] = useState();
  const [stateData, setStateData] = useState([
    {
      value: "",
      label: "",
    },
  ]);
  const [cityData, setCityData] = useState([
    {
      value: "",
      label: "",
    },
  ]);

  const navigate = useNavigate();
  const initPhotoFile = {
    photo: "",
    photoFileType: "",
    photoBucketUrl: "",
    photoFileName: "",
  };
  const prflActionRequired = getUserInfo("prflActionRequired");

  useEffect(() => {
    setDisableCompanyDtls(
      LINEHAUL_CUSTOMER_USER_TYPE_LIST.includes(getUserInfo("userType"))
    );
    setIsUserActive(getUserInfo("userActive"));
    fetchCustDetails();
    fetchStatesAndCityList();
  }, [reload]);

  useEffect(() => {
    if (custPrflDetails.user_picture && custPrflDetails.user_picture !== "") {
      setImageData(custPrflDetails.user_picture);
    } else {
      setImageData("");
    }
  }, [custPrflDetails]);
  const [photoImg, setPhotoImg] = useState();
  const [photoFile, setPhotoFile] = useState(initPhotoFile);
  const [imageData, setImageData] = useState(initPhotoFile);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    control,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: custPrflDetails,
  });
  const {
    fields: generalDocList,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "generalDocList",
  });
  const fetchCustDetails = async () => {
    setShow(true);
    let uri = `get-cust-prfl?profileId=${getUserInfo("acctId")}`;
    let data = await CallApiGet(uri);

    if (data.respCode === 200 || data.respCode === 0) {
      let respDatas = data.respData[0];
      if (respDatas?.genDocList?.length > 0) {
        let jsonString = respDatas.genDocList;
        const arrayOfObjects = JSON.parse(jsonString);
        respDatas.genDocList = arrayOfObjects;
      }
      setUserInfo("userName", respDatas.custName);
      setCustPrflDetails(respDatas);
      let custPrflDetails = respDatas;
      Object.entries(custPrflDetails).forEach(([key, val]) => {
        if (typeof val !== "undefined" && val !== "null" && val !== null) {
          switch (key) {
            case "picSalesStaffName":
              let sales = val + "( " + custPrflDetails.picSalesStaffId + " )";
              setValue(key, sales);
              break;
            case "custPhone":
              setValue("custPhoneCode", val.substr(0, 3));
              setValue("custPhone", val.substr(3));
              break;
            // case "pickupPhone":
            //   setValue("pickupPhoneCode", val.substr(0, 3));
            //   setValue("pickupPhone", val.substr(3));
            //   break;
            case "bankStatement":
              setValue(
                "bankStatement.photoFileName",
                respDatas?.bankStatement?.split("/").pop()
              );
              setValue(
                "bankStatement.photoBucketUrl",
                respDatas?.bankStatement
              );
              break;
            case "ssmDoc":
              setValue(
                "ssmDoc.photoFileName",
                respDatas?.ssmDoc?.split("/").pop()
              );
              setValue("ssmDoc.photoBucketUrl", respDatas?.ssmDoc);
              break;
            default:
              setValue(key, val);
              break;
          }
        } else {
          setValue(key, "");
        }
      });
      setShow(false);
    } else {
      setShow(false);
      navigate(-1);
    }
  };

  const onSubmit = async (data) => {
    setShow(true);
    data.custPhone = data.custPhoneCode + data.custPhone;
    //data.pickupPhone = data.pickupPhoneCode + data.pickupPhone;

    delete data.custPhoneCode;
    //delete data.pickupPhoneCode;
    delete data.picSalesStaffId;
    delete data.picSalesStaffName;
    delete data.picCreditStaffId;
    delete data.picCreditStaffName;
    delete data.rateChartUrl;

    data["rateChart"] = null;
    data["updatedBy"] = getUserInfo("userId");

    if (data?.profilePhoto?.length === 0) {
      data.profilePhoto.photoBucketUrl = data.user_picture;
    }
    const uri = "update-cust-profile";
    let resp = await CallApiPut(uri, data);

    if (resp.respCode === 200 || resp.respCode === 0) {
      // Set updated prflActionRequired value
      if (resp.respData && resp.respData.length > 0 && resp.respData[0]) {
        if (
          resp.respData[0].PrflActionRequired ||
          resp.respData[0].PrflActionRequired === false
        ) {
          setUserInfo(
            "prflActionRequired",
            resp.respData[0].PrflActionRequired
          );
        }
      }
      // reset(initCustProfile);
      setShow(false);
      onSuccess("Profile details updated successfully !!!");
    } else if (data.respCode === 400 || data.respCode === 401) {
      setShow(false);
      setIsSuccess(false);
      setTitle("UNAUTHORIZED");
      setDescription("Sorry, you don't have the write permission!!");
      modalRef.current.click();
    } else {
      setShow(false);
      onFailure();
    }
  };

  const onSuccess = (sucMsg) => {
    setIsSuccess(true);
    setTitle("Congratulations");
    setDescription(sucMsg);
    modalRef.current.click();
  };

  const onFailure = () => {
    setIsSuccess(false);
    setTitle("Error");
    setDescription(SERVER_ERR_MSG);
    modalRef.current.click();
  };

  const callback = () => {
    setReload((reload) => reload + 1);
  };

  const onError = (error) => {
    console.error(error);
  };

  const handleCancel = () => {
    navigate("/dashboard");
  };

  const getApprovalHistory = async () => {
    setShow(true);
    let approvalHistoryData = await approvalHistory(
      custPrflDetails.profileId,
      custPrflDetails.custType
    );
    setShow(false);
    if (approvalHistoryData.respCode === 200) {
      let data = approvalHistoryData.respData;
      setApprovalHistoryData(data);
    } else if (approvalHistoryData.respCode === 500) {
      onFailure();
    } else {
      setApprovalHistoryData([]);
      localStorage.clear();
      navigate("/login");
    }
  };
  const selectPhotoFile = async (event) => {
    const file = event.target.files;

    if (file.length === 0) {
    } else {
      var fileName = file[0].name;
      setPhotoImg(file[0]);
      var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var photo = "";
      try {
        photo = await toBase64(file[0]);
      } catch (error) {
        console.error(error);
      }

      const newAttachment = {
        photo: photo,
        photoFileType: ext,
        photoBucketUrl: "",
        photoFileName: fileName,
      };
      setPhotoFile(newAttachment);
      setValue("profilePhoto", newAttachment);
      // clearErrors("profileDoc");
      // setPhotoImgErrMsg();
    }
  };
  const bankStatementPlaceHolder = watch(
    "bankStatement.photoFileName",
    "Upload Bank Statement"
  );
  const ssmDocPlaceHolder = watch(
    "ssmDoc.photoFileName",
    "Upload SSM Document"
  );
  const selectBankAndSSMFile = async (key, event) => {
    let newAttachment = {};
    const file = event.target.files;

    if (file.length === 0) {
      newAttachment = {
        photo: "",
        photoFileName: "",
        photoFileType: "",
        photoBucketUrl: "",
      };
    } else {
      var fileName = file[0].name;
      var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var photo = "";
      try {
        photo = await toBase64(file[0]);
      } catch (error) {
        console.error(error);
      }

      newAttachment = {
        photo: photo,
        photoFileName: fileName,
        photoFileType: ext,
        photoBucketUrl: fileName,
      };
    }
    setValue(`${key}.photo`, newAttachment.photo);
    setValue(`${key}.photoFileName`, newAttachment.photoFileName);
    setValue(`${key}.photoFileType`, newAttachment.photoFileType);
    setValue(`${key}.photoBucketUrl`, newAttachment.photoBucketUrl);
    clearErrors(key);
  };
  const download = (fileName) => {
    window.open(fileName, "_blank");
  };
  const watchCustEmail = watch("custEmail");
  const fetchStatesAndCityList = async () => {
    let stateArrList = [];
    let stateArr = [];
    let cityArrList = [];
    let cityArr = [];
    let data = await CallApiGet("getStateAndCityList");
    setStateCity(data.respData);
    data.respData.forEach((element) => {
      if (!stateArr.includes(element.map_state)) {
        stateArrList.push({
          value: element.map_state,
          label: element.map_state,
        });
      }
      if (!cityArr.includes(element.map_city)) {
        cityArrList.push({
          value: element.map_city,
          label: element.map_city,
        });
      }
      stateArr.push(element.map_state);
      cityArr.push(element.map_city);
    });
    setStateData(stateArrList);
    setCityData(cityArrList);
    setCityListData(cityArrList);
    setCompCityListData(cityArrList)
  };

  const filterCity = (state) => {
    let cityArrList = [];
    if (state) {
      let setCity = new Set(
        stateCity.filter((a) => {
          return a.map_state === state;
        })
      );

      setCity.forEach((element) => {
        cityArrList.push({
          value: element.map_city,
          label: element.map_city,
        });
      });
      setCityListData(cityArrList);
      setValue("city", "");
    } else {
      setCityListData(cityData);
    }
  };

  const filterCompCity = (state) => {
    let cityArrList = [];
    if (state) {
      let setCity = new Set(
        stateCity.filter((a) => {
          return a.map_state === state;
        })
      );

      setCity.forEach((element) => {
        cityArrList.push({
          value: element.map_city,
          label: element.map_city,
        });
      });
      setCompCityListData(cityArrList);
      setValue("businessCity", "");
    } else {
      setCompCityListData(cityData);
    }
  };

  const filterState = (city, stateFieldName = "state") => {
    if (city) {
      let flt = stateCity.filter((a) => {
        return a.map_city === city;
      });

      setValue(stateFieldName, flt[0].map_state);
      clearErrors(stateFieldName);
    } else {
      setValue(stateFieldName, "");
    }
  };
  const disableCondForCust = () => {
    [
      LINEHAUL_CUSTOMER_USER_TYPE_BUSINESS,
      LINEHAUL_AGENT_CUSTOMER_USER_TYPE,
    ].includes(custPrflDetails?.custType);
  };
  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <main className="col-md-12 p-3">
            <div className="clearfix border-bottom pb-2">
              <div className="float-start">
                <div className="section-title mt-1">Profile Details</div>
              </div>
            </div>
            <div className="alert alert-info my-4">
              <div>
                <div className="float-start">
                  <h5 className="card-title">Current Approval Status:</h5>
                  <p className="card-text">{custPrflDetails.approvalStatus}</p>
                </div>
                {permission(APVLLOG).allowedRead && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary theme-violet me-1 float-end"
                    onClick={getApprovalHistory}
                    data-bs-toggle="modal"
                    data-bs-target="#approval-history-modal"
                  >
                    Approval History
                  </button>
                )}
                <div className="clearfix"></div>
              </div>
            </div>
            {prflActionRequired === "true" && (
              <div
                class="alert alert-danger d-flex align-items-left"
                role="alert"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  class="bi bi-exclamation-triangle-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                </svg>
                <div style={{ marginLeft: "10px" }}>
                  To ensure continued access and optimal service, your profile
                  requires an update. Failure to update may result in temporary
                  service restrictions.
                </div>
              </div>
            )}
            <div className="row mt-4">
              <div className="col-md-2 d-none">
                <nav className="nav flex-column profile-action" id="nav-tab">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#success-modal"
                    id="modalPopup"
                    className="d-none"
                    ref={modalRef}
                  />
                </nav>
              </div>
              <div className="col-md-12 mt-2">
                <div className="row" id="nav-tabContent">
                  <div className="mb-4">
                    <div
                      className="d-block show border border-2 p-2"
                      id="nav-Personal"
                      role="tabpanel"
                      aria-labelledby="nav-Personal-tab"
                    >
                      <h5 className="theme-violet-txt mb-3">
                        Personal Details
                      </h5>
                      <div className="row">
                        <input type="hidden" {...register("profileId")} />
                        <div className="col-md-3">
                          <div
                            className="mb-2 file-placeholder thumbnail-pic d-flex justify-content-center"
                            {...register("profilePhoto")}
                          >
                            <input
                              type="file"
                              accept="image/png, image/jpeg "
                              onChange={selectPhotoFile}
                            />
                            {photoImg ? (
                              <img
                                src={URL.createObjectURL(photoImg)}
                                alt="img"
                              />
                            ) : imageData !== "" ? (
                              <img
                                src={imageData !== "" ? imageData : ""}
                                alt="img"
                              />
                            ) : (
                              <div>
                                {/* {GetSvgUpload({ required: false })} */}
                                Upload Photo{" "}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="This field is mandatory"
                          >
                            Name{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <input
                            type="text"
                            className="form-control"
                            {...register("custName", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                          />
                          {errors.custName && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.custName.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Phone{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <div className="input-group">
                            <select
                              name="custPhoneCode"
                              {...register("custPhoneCode")}
                              defaultValue="+60"
                              className="form-control country-code-customize"
                            >
                              {COUNTRY_CODES.map((cc, index) => (
                                <option key={index} value={cc.value}>
                                  {cc.label}
                                </option>
                              ))}
                            </select>
                            <input
                              type="text"
                              className="form-control"
                              maxLength="11"
                              {...register("custPhone", {
                                pattern: {
                                  value: PHONE_NUM,
                                  message: PATTERN_ERR_MSG,
                                },
                                required: {
                                  value: true,
                                  message: REQUIRED_ERR_MSG,
                                },
                              })}
                            />
                          </div>
                          {errors.custPhone && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.custPhone.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Email{" "}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            maxLength="200"
                            {...register("custEmail", {
                              pattern: {
                                value: EMAIL,
                                message: "Incorrect Data",
                              },
                            })}
                            disabled={
                              watchCustEmail !== undefined &&
                              watchCustEmail !== ""
                            }
                          />
                          {errors.custEmail && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.custEmail.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            {LINEHAUL_AGENT_CUSTOMER_USER_TYPE ===
                            getUserInfo("userType")
                              ? "Sales Partner IC"
                              : "Customer IC"}{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <input
                            type="text"
                            className="form-control"
                            maxLength="50"
                            {...register("custIc", {
                              pattern: {
                                value: ALPHANUM,
                                message: "Accepts Alphanumeric values!",
                              },
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                          />
                          {errors.custIc && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.custIc.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="This field is mandatory"
                          >
                            State{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <Controller
                            name="state"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                options={stateData}
                                placeholder="Select State"
                                value={
                                  value
                                    ? stateData.filter((opt) =>
                                        value.includes(opt.value)
                                      )
                                    : value
                                }
                                onChange={(d) =>
                                  onChange(
                                    d ? d.value : d,
                                    filterCity(d ? d.value : d)
                                  )
                                }
                                isSearchable={true}
                                isClearable={true}
                                isDisabled={
                                  !(
                                    getUserInfo("userActive") === "true" &&
                                    disableCondForCust
                                  )
                                }
                                className="form-control  p-0 border-end-0 pe-1"
                              />
                            )}
                            rules={{
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            }}
                          />
                          {errors.state && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.state.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="This field is mandatory"
                          >
                            City{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <Controller
                            name="city"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                options={cityListData}
                                placeholder="Select City"
                                value={
                                  value
                                    ? cityListData.filter((opt) =>
                                        value.includes(opt.value)
                                      )
                                    : value
                                }
                                onChange={(d) =>
                                  onChange(
                                    d ? d.value : d,
                                    filterState(d ? d.value : d)
                                  )
                                }
                                isSearchable={true}
                                isClearable={true}
                                isDisabled={
                                  !(
                                    getUserInfo("userActive") === "true" &&
                                    disableCondForCust
                                  )
                                }
                                className="form-control  p-0  border-end-0 pe-1"
                              />
                            )}
                            rules={{
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            }}
                          />
                          {errors.city && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.city.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="This field is mandatory"
                          >
                            Postcode{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <input
                            type="text"
                            className="form-control"
                            disabled={
                              !(
                                getUserInfo("userActive") === "true" &&
                                disableCondForCust
                              )
                            }
                            {...register("postcode", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                              pattern: {
                                value: NUMBER_REGEX,
                                message: "Accepts Numeric values!",
                              },
                            })}
                          />
                          {errors.postcode && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.postcode.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-6 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Address{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <textarea
                            className="form-control"
                            maxLength="200"
                            {...register("custAddr", {
                              pattern: {
                                value: ALPHANUM_SPACE_SPCL_CHAR,
                                message: PATTERN_ERR_MSG,
                              },
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                          ></textarea>
                          {errors.custAddr && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.custAddr.message}
                              </span>
                            </div>
                          )}
                        </div>
                        {LINEHAUL_CUSTOMER_USER_TYPE_PERSONAL ===
                          custPrflDetails?.custType.toString() && (
                          <>
                            <div className="col-lg-6 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Tax Identification Number{" "}
                              </label>
                              <span className="text-danger">&#9733;</span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Tax Identification Number"
                                aria-label=""
                                aria-describedby="basic-addon1"
                                name="tin"
                                {...register("tin", {
                                  required: {
                                    value: true,
                                    message: REQUIRED_ERR_MSG,
                                  },
                                  pattern: {
                                    value: ALPHANUM,
                                    message: PATTERN_ERR_MSG,
                                  },
                                })}
                                maxLength="200"
                              />
                              {errors.tin && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.tin.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                e-Invoice Email{" "}
                              </label>
                              <span className="text-danger">&#9733;</span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="e-Invoice Email"
                                aria-label="Email"
                                aria-describedby="basic-addon1"
                                name="einvoiceEmail"
                                {...register("einvoiceEmail", {
                                  required: {
                                    value: true,
                                    message: REQUIRED_ERR_MSG,
                                  },
                                  pattern: {
                                    value: EMAIL,
                                    message: PATTERN_ERR_MSG,
                                  },
                                })}
                                maxLength="200"
                              />

                              {errors.einvoiceEmail && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.einvoiceEmail.message}
                                  </span>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {/*  */}
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  </div>

                  {LINEHAUL_CUSTOMER_BUSINESS_PARTNERS.includes(
                    custPrflDetails?.custType.toString()
                  ) && (
                    <>
                      <div className="mb-4">
                        <div
                          className="d-block show border border-2 p-2"
                          id="nav-Company"
                          role="tabpanel"
                        >
                          <h5 className="theme-violet-txt">Company Details</h5>
                          <div className="row">
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Company Name{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength="200"
                                disabled={disableCompanyDtls}
                                {...register("businessName")}
                              />
                              {errors.businessName && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.businessName.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Company Regd. Number (Old){" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                disabled={disableCompanyDtls}
                                {...register("businessRegno", {})}
                                maxLength="30"
                                placeholder="Company Regd. Number (Old)"
                              />
                              {errors.businessRegno && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.businessRegno.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Company Regd. Number (New){" "}
                              </label>
                              <span className="text-danger">&#9733;</span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Company Regd. Number (New)"
                                aria-label="Phone"
                                aria-describedby="basic-addon1"
                                name="companyRegNoNew"
                                {...register("companyRegNoNew", {
                                  required: {
                                    value: true,
                                    message: REQUIRED_ERR_MSG,
                                  },
                                  pattern: {
                                    value: COMPANY_REGD_NO_REGEX_FIXED,
                                    message: "Field accepts 12 digit number!!",
                                  },
                                })}
                                maxLength="12"
                              />

                              {errors.companyRegNoNew && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.companyRegNoNew.message}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          {LINEHAUL_AGENT_CUSTOMER_USER_TYPE === custPrflDetails?.custType.toString() && (
                            <>
                              <div className="row">
                                <div className="col-lg-4 mb-2">
                                  <label
                                    htmlFor=""
                                    className="form-label theme-label"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    title="This field is mandatory"
                                  >
                                    State{" "}
                                  </label>
                                  <span className="text-danger">&#9733;</span>
                                  <Controller
                                    name="businessState"
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                      <Select
                                        options={stateData}
                                        placeholder="Select State"
                                        value={
                                          value
                                            ? stateData.filter((opt) =>
                                                value.includes(opt.value)
                                              )
                                            : value
                                        }
                                        onChange={(d) =>
                                          onChange(
                                            d ? d.value : d,
                                            filterCompCity(d ? d.value : d)
                                          )
                                        }
                                        isSearchable={true}
                                        isClearable={true}
                                        isDisabled={
                                          !(
                                            getUserInfo("userActive") === "true" &&
                                            disableCondForCust
                                          )
                                        }
                                        className="form-control  p-0 border-end-0 pe-1"
                                      />
                                    )}
                                    rules={{
                                      required: {
                                        value: (
                                          getUserInfo("userActive") === "true" &&
                                          disableCondForCust
                                        ),
                                        message: REQUIRED_ERR_MSG,
                                      },
                                    }}
                                  />
                                  {errors.businessState && (
                                    <div>
                                      <span className="badge bg-danger">
                                        &#9888; {errors.businessState.message}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-4 mb-2">
                                  <label
                                    htmlFor=""
                                    className="form-label theme-label"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    title="This field is mandatory"
                                  >
                                    City{" "}
                                  </label>
                                  <span className="text-danger">&#9733;</span>
                                  <Controller
                                    name="businessCity"
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                      <Select
                                        options={compCityListData}
                                        placeholder="Select City"
                                        value={
                                          value
                                            ? compCityListData.filter((opt) =>
                                                value.includes(opt.value)
                                              )
                                            : value
                                        }
                                        onChange={(d) =>
                                          onChange(
                                            d ? d.value : d,
                                            filterState(d ? d.value : d, "businessState")
                                          )
                                        }
                                        isSearchable={true}
                                        isClearable={true}
                                        isDisabled={
                                          !(
                                            getUserInfo("userActive") === "true" &&
                                            disableCondForCust
                                          )
                                        }
                                        className="form-control  p-0  border-end-0 pe-1"
                                      />
                                    )}
                                    rules={{
                                      required: {
                                        value: (
                                          getUserInfo("userActive") === "true" &&
                                          disableCondForCust
                                        ),
                                        message: REQUIRED_ERR_MSG,
                                      },
                                    }}
                                  />
                                  {errors.businessCity && (
                                    <div>
                                      <span className="badge bg-danger">
                                        &#9888; {errors.businessCity.message}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <div className="col-lg-4 mb-2">
                                  <label
                                    htmlFor=""
                                    className="form-label theme-label"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    title="This field is mandatory"
                                  >
                                    Postcode{" "}
                                  </label>
                                  <span className="text-danger">&#9733;</span>
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled={
                                      !(
                                        getUserInfo("userActive") === "true" &&
                                        disableCondForCust
                                      )
                                    }
                                    {...register("businessPostcode", {
                                      required: {
                                        value: (
                                          getUserInfo("userActive") === "true" &&
                                          disableCondForCust
                                        ),
                                        message: REQUIRED_ERR_MSG,
                                      },
                                      pattern: {
                                        value: NUMBER_REGEX,
                                        message: "Accepts Numeric values!",
                                      },
                                    })}
                                  />
                                  {errors.businessPostcode && (
                                    <div>
                                      <span className="badge bg-danger">
                                        &#9888; {errors.businessPostcode.message}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12 mb-2">
                                  <label
                                    htmlFor=""
                                    className="form-label theme-label"
                                    title="This field is mandatory"
                                  >
                                    Address{" "}
                                  </label>
                                  <span className="text-danger">&#9733;</span>
                                  <textarea
                                    className="form-control"
                                    maxLength="200"
                                    {...register("businessAddr", {
                                      pattern: {
                                        value: ALPHANUM_SPACE_SPCL_CHAR,
                                        message: PATTERN_ERR_MSG,
                                      },
                                      required: {
                                        value: true,
                                        message: REQUIRED_ERR_MSG,
                                      },
                                    })}
                                  ></textarea>
                                  {errors.businessAddr && (
                                    <div>
                                      <span className="badge bg-danger">
                                        &#9888; {errors.businessAddr.message}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                          <div className="row">
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Sales Representative{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                {...register("picSalesStaffName")}
                                disabled
                              />
                            </div>
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Tax Identification Number{" "}
                              </label>
                              <span className="text-danger">&#9733;</span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Tax Identification Number"
                                aria-label=""
                                aria-describedby="basic-addon1"
                                name="tin"
                                {...register("tin", {
                                  required: {
                                    value: true,
                                    message: REQUIRED_ERR_MSG,
                                  },
                                  pattern: {
                                    value: ALPHANUM,
                                    message: PATTERN_ERR_MSG,
                                  },
                                })}
                                maxLength="200"
                              />
                              {errors.tin && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.tin.message}
                                  </span>
                                </div>
                              )}
                            </div>

                            {/* email new */}
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                e-Invoice Email{" "}
                              </label>
                              <span className="text-danger">&#9733;</span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="e-Invoice Email"
                                aria-label="Email"
                                aria-describedby="basic-addon1"
                                name="einvoiceEmail"
                                {...register("einvoiceEmail", {
                                  required: {
                                    value: true,
                                    message: REQUIRED_ERR_MSG,
                                  },
                                  pattern: {
                                    value: EMAIL,
                                    message: PATTERN_ERR_MSG,
                                  },
                                })}
                                maxLength="200"
                              />

                              {errors.einvoiceEmail && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.einvoiceEmail.message}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="row">
                            {/* MISC Code */}
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                MISC Code
                              </label>
                              {/* <span className="text-danger">&#9733;</span> */}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="MISC Code"
                                aria-label=""
                                aria-describedby="basic-addon1"
                                name="miscCode"
                                {...register("miscCode", {
                                  // required: {
                                  //   value: true,
                                  //   message: REQUIRED_ERR_MSG,
                                  // },
                                  pattern: {
                                    value: POST_CODE,
                                    message: "Field accepts 5 digit number!!",
                                  },
                                })}
                                maxLength="5"
                              />

                              {errors.miscCode && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.miscCode.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            {/* Business Nature */}
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Business Nature
                              </label>
                              {/* <span className="text-danger">&#9733;</span> */}
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Business Nature"
                                aria-label=""
                                aria-describedby="basic-addon1"
                                name="businessNature"
                                {...register("businessNature", {
                                  // required: {
                                  //   value: true,
                                  //   message: REQUIRED_ERR_MSG,
                                  // },
                                })}
                                maxLength="1000"
                              />

                              {errors.businessNature && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.businessNature.message}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="clearfix"></div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <div
                          className="d-block show border border-2 p-2"
                          id="nav-Company"
                          role="tabpanel"
                        >
                          <h5 className="theme-violet-txt">SST Exemption </h5>
                          <div className="row">
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                SST Exempted{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength="200"
                                disabled={disableCompanyDtls}
                                value={
                                  custPrflDetails.sstExempt === true
                                    ? "YES"
                                    : "NO"
                                }
                              />
                            </div>
                            {watch("sstExempt") === true && (
                              <div className="col-lg-4 mb-2">
                                <label
                                  htmlFor=""
                                  className="form-label theme-label"
                                  title="This field is mandatory"
                                >
                                  SST Start Date{" "}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={
                                    !!custPrflDetails.sstExemptStartDate
                                      ? moment(
                                          custPrflDetails.sstExemptStartDate
                                        ).format(DATE_FORMAT_MOMENT)
                                      : ""
                                  }
                                  disabled
                                />
                              </div>
                            )}

                            <>
                              <div className="col-lg-4 mb-2">
                                <label
                                  htmlFor=""
                                  className="form-label theme-label"
                                  title="This field is mandatory"
                                >
                                  SST Regd. Number (Service Tax){" "}
                                </label>
                                <span className="text-danger">&#9733;</span>
                                {/* <input
                                    type="text"
                                    className="form-control"
                                    disabled={disableCompanyDtls}
                                    value={custPrflDetails.sstNumber}
                                  /> */}
                                <Controller
                                  name="sstNumber"
                                  control={control}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: "This field is required",
                                    },
                                    pattern: {
                                      value: ALPHANUM,
                                      message: PATTERN_ERR_MSG,
                                    },
                                  }}
                                  render={({ field }) => (
                                    <>
                                      <CustomizeList
                                        value={watch("sstNumber")}
                                        onChange={(value) =>
                                          field.onChange(value || "")
                                        }
                                        placeholder="SST Regd. Number (Service Tax)"
                                      />
                                      {/* <CreatableSelect
                                        options={sstOptions}
                                        className="form-control border-end-0 pe-1 custom-col-height"
                                        isClearable
                                        placeholder="SST Regd. No. (Service Tax)"
                                        onChange={(option) =>
                                          field.onChange(option?.value || "")
                                        }
                                        value={
                                          field.value
                                            ? {
                                                label: field.value,
                                                value: field.value,
                                              }
                                            : null
                                        }
                                      /> */}
                                    </>
                                  )}
                                />

                                {errors.sstNumber && (
                                  <div>
                                    <span className="badge bg-danger">
                                      &#9888; {errors.sstNumber.message}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </>
                            <div className="col-lg-4 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                SST Regd. Number (Sales Tax)
                              </label>
                              <span className="text-danger">&#9733;</span>
                              {/* <input
                                  type="text"
                                  className="form-control"
                                  placeholder="SST Regd. Number (Sales Tax)"
                                  aria-label=""
                                  aria-describedby="basic-addon1"
                                  name="sstNumberSales"
                                  {...register("sstNumberSales", {
                                    required: {
                                      value: true,
                                      message: REQUIRED_ERR_MSG,
                                    },
                                    pattern: {
                                      value: ALPHANUM,
                                      message: PATTERN_ERR_MSG,
                                    },
                                  })}
                                  maxLength="200"
                                /> */}
                              <Controller
                                name="sstNumberSales"
                                className="form-control  border-end-0 pe-1"
                                control={control}
                                rules={{
                                  required: {
                                    value: true,
                                    message: "This field is required",
                                  },
                                  pattern: {
                                    value: ALPHANUM,
                                    message: PATTERN_ERR_MSG,
                                  },
                                }}
                                render={({ field, fieldState }) => (
                                  <>
                                    <CustomizeList
                                      value={watch("sstNumberSales")}
                                      onChange={(value) =>
                                        field.onChange(value || "")
                                      }
                                      placeholder="SST Regd. No. (Sales Tax)"
                                    />
                                  </>
                                )}
                              />
                              {errors.sstNumberSales && (
                                <div>
                                  <span className="badge bg-danger">
                                    &#9888; {errors.sstNumberSales.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            {/* <input
                              type="hidden"
                              {...register("businessAddr")}
                            /> */}
                          </div>
                          <div className="clearfix"></div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-12 mb-4">
                    <div
                      className="d-block show border border-2 p-2"
                      id="nav-Bank"
                      role="tabpanel"
                    >
                      <h5 className="theme-violet-txt">Bank Details</h5>
                      <div className="row">
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Bank Name{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <input
                            type="text"
                            className="form-control"
                            maxLength="200"
                            {...register("bankName", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                          />
                          {errors.bankName && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.bankName.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Bank Account{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <input
                            type="text"
                            className="form-control"
                            maxLength="200"
                            {...register("bankAcct", {
                              pattern: {
                                value: ALPHANUM,
                                message: "Accepts Alphanumeric values!",
                              },
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                          />
                          {errors.bankAcct && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.bankAcct.message}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-lg-3 mb-2">
                          <label
                            htmlFor=""
                            className="form-label theme-label"
                            title="This field is mandatory"
                          >
                            Benificiary Name{" "}
                          </label>
                          <span className="text-danger">&#9733;</span>
                          <input
                            type="text"
                            className="form-control"
                            maxLength="200"
                            {...register("benificiaryName", {
                              required: {
                                value: true,
                                message: REQUIRED_ERR_MSG,
                              },
                            })}
                          />
                          {errors.benificiaryName && (
                            <div>
                              <span className="badge bg-danger">
                                &#9888; {errors.benificiaryName.message}
                              </span>
                            </div>
                          )}
                        </div>

                        {LINEHAUL_CUSTOMER_BUSINESS_PARTNERS.includes(
                          custPrflDetails?.custType.toString()
                        ) && (
                          <>
                            <div className="col-lg-3 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                                title="This field is mandatory"
                              >
                                Requested Credit Amount{" "}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength="200"
                                {...register("reqCreditLimit", {
                                  pattern: {
                                    value: NUMBER_TWO_DECIMAL,
                                    message:
                                      "Accepts numeric value with2 Decimal!",
                                  },
                                  setValueAs: (v) => {
                                    const val = parseFloat(v);
                                    return isNaN(val) ? v : val;
                                  },
                                })}
                                disabled
                              />
                            </div>
                            <div className="col-lg-3 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                              >
                                Bank Statement{" "}
                              </label>
                              <div
                                className="Upload-Photo w-100 mb-2"
                                {...register("bankStatement")}
                              >
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    selectBankAndSSMFile("bankStatement", e)
                                  }
                                />
                                <div className="uploaded-text ms-2">
                                  {GetSvgUpload({ required: false })}
                                  {bankStatementPlaceHolder
                                    ? bankStatementPlaceHolder
                                    : "Upload Bank Statement"}
                                </div>
                                <button
                                  type="button"
                                  style={{
                                    marginTop: "-30px",
                                    marginRight: "-13px",
                                  }}
                                  className="btn btn-outline-secondary theme-violet position-absolute download-uploaded-file"
                                  disabled={
                                    isDisabled[
                                      `bankStatement.photoBucketUrl` +
                                        "attachment"
                                    ]
                                  }
                                  onClick={() =>
                                    download(
                                      watch("bankStatement.photoBucketUrl")
                                    )
                                  }
                                >
                                  {GetSvgIcon("IconFiledownload")}
                                </button>
                              </div>
                            </div>
                            <div className="col-lg-3 mb-2">
                              <label
                                htmlFor=""
                                className="form-label theme-label"
                              >
                                SSM Document{" "}
                              </label>
                              <div
                                className="Upload-Photo w-100 mb-2"
                                {...register("ssmDoc")}
                              >
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    selectBankAndSSMFile("ssmDoc", e)
                                  }
                                />
                                <div className="uploaded-text ms-2">
                                  {GetSvgUpload({ required: false })}
                                  {ssmDocPlaceHolder
                                    ? ssmDocPlaceHolder
                                    : "Upload SSM Document"}
                                </div>
                                <button
                                  type="button"
                                  style={{
                                    marginTop: "-30px",
                                    marginRight: "-13px",
                                  }}
                                  className="btn btn-outline-secondary theme-violet position-absolute download-uploaded-file"
                                  disabled={
                                    isDisabled[
                                      `ssmDoc.photoBucketUrl` + "attachment"
                                    ]
                                  }
                                  onClick={() =>
                                    download(watch("ssmDoc.photoBucketUrl"))
                                  }
                                >
                                  {GetSvgIcon("IconFiledownload")}
                                </button>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  </div>
                  {LINEHAUL_CUSTOMER_BUSINESS_PARTNERS.includes(
                    custPrflDetails?.custType.toString()
                  ) && (
                    <>
                      <div className="col-md-12 mb-4">
                        <div
                          className="d-block show border border-2 p-2"
                          id="nav-Bank"
                          role="tabpanel"
                        >
                          <h5 className="theme-violet-txt">General Document</h5>
                          <div className="row">
                            {custPrflDetails?.genDocList?.map((item, index) => (
                              <>
                                <div
                                  className="col-md-4 mb-2 position-relative"
                                  key={index}
                                >
                                  <div className="Upload-Photo w-100">
                                    <div
                                      className="uploaded-text ms-2"
                                      disabled
                                    >
                                      {item.photoFileName.split("/").pop()}
                                    </div>
                                  </div>
                                  <button
                                    type="button"
                                    style={{ marginTop: "-28px" }}
                                    className="btn btn-outline-secondary theme-violet position-absolute download-uploaded-file"
                                    onClick={() => download(item.photoFileName)}
                                  >
                                    {GetSvgIcon("IconFiledownload")}
                                  </button>
                                </div>
                              </>
                            ))}
                          </div>
                          <MultipleFileUpload
                            customData={customData}
                            customCss={customCss}
                            register={register}
                            clearErrors={clearErrors}
                            setValue={setValue}
                            watch={watch}
                            control={control}
                            remove={remove}
                            append={append}
                            generalDocList={generalDocList}
                          />
                          <div className="clearfix"></div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="clearfix"></div>
                  <div className="w-100 text-end">
                    {isUserActive === "true" &&
                      prflActionRequired === "false" && (
                        <button
                          type="button"
                          className="btn btn-default border me-2"
                          data-bs-dismiss="modal"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                      )}

                    <button
                      type="button"
                      className="btn btn-outline-secondary theme-violet"
                      onClick={handleSubmit(onSubmit, onError)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ApprovalLogList data={approvalHistoryData} />
      <Popup
        isSuccess={isSuccess}
        title={title}
        description={description}
        handler={callback}
      />
      <Spinner show={show} />
    </div>
  );
};

export default CustomerProfile;
